/**
 * Label of the Terms & Conditions checkbox in the GPO New pharmacy flow and
 * the partner Organization profile. The server records the same text as the
 * acceptance intent (`_TERMS_INTENT`), so the two must stay identical.
 */
export const TERMS_AGREEMENT_LABEL = "I agree to DearBill's Terms & Conditions";
